@if (productPlan) {
  <panel width="450">
    <form>
      <h1>{{ 'company.product-plans.edit-termination-notice-period' | translate }}</h1>
      <section>
        <custom-select [selectList]="terminationNoticePeriods" [(value)]="updatedPeriod" [required]="true" [label]="'company.product-plans.termination-notice-period-months' | translate" />
      </section>
      <section>
        <button confirm (click)="saveProductPlan()" [label]="'general.save' | translate"></button>
      </section>
    </form>
  </panel>
}
